module.exports = __webpack_public_path__ + "img/img-thumbnail-02.41890585.png";